import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "e-card-actions" }

import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import {onMounted, reactive, ref, watch} from "vue";
import SogButton from "@/shared/ui/SogButton.vue";
import {useRoute} from "vue-router";
import notificationService from "@/shared/services/NotificationService";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";
import Person from "@/shared/model/person";
import PersonAddressForm from "@/modules/OrganisationStructure/components/PersonAddressEditComponent.vue";
import apiInsurance from "@/modules/Insurance/api";
import Address from "@/shared/model/Address";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";


export default /*@__PURE__*/_defineComponent({
  __name: 'EvbActivation',
  setup(__props) {

const _code = reactive({code1:"",code2:"",code3:""})
const _isActivateDisabled = ref(true)
const _isShowActivationForm = ref(false)
const _insuranceIds = reactive<string[]>([])
const _evbs = reactive<string[]>([])
const testValidation:SogFormValidationRule[]=[
  {name:'activationDuration',rules:{required:[true,"1 bis 90 Tage"],min:1,max:90}},
]

const inputCode1 = ref<InstanceType<typeof SogTextBox>  | null>(null)
const inputCode2 = ref<InstanceType<typeof SogTextBox>  | null>(null)
const inputCode3 = ref<InstanceType<typeof SogTextBox>  | null>(null)
const btnSearch = ref<InstanceType<typeof SogButton>  | null>(null)

const formActivation = ref<InstanceType<typeof SogForm>  | null>(null)
const _personAddressForm = ref<InstanceType<typeof PersonAddressForm>  | null>(null)

const _value =  reactive({activationDuration:30,person:new Person(),address:new Address()})


const route = useRoute()



watch(
  () => route.params.code,
  () => {
    setCode(route.params.code as string)
  }
)


watch(_code,(newValue)=>{
  if(newValue.code1.length===3){
    inputCode2.value.focus()
  }
  if(newValue.code2.length===3){
    inputCode3.value.focus()
  }
  if(newValue.code3.length===3){
    btnSearch.value.focus()
  }
  _isActivateDisabled.value = _code.code1.length<3 ||_code.code2.length<3||_code.code3.length<3
})

watch([_insuranceIds],()=>{
  _isShowActivationForm.value = _insuranceIds.length>0
})

const onClick = function(){
  checkActivationCode()
}

onMounted(()=>{
  inputCode1.value?.focus()
  setCode(route.params.code as string)
})

function setCode(value:string|undefined) {
  if(value && value.length === 11 ) {
    _code.code1 = value.substring(0,3)
    _code.code2 = value.substring(4,7)
    _code.code3 = value.substring(8,11)
    checkActivationCode()
  }
}

function onActivationCancel() {
  _insuranceIds.length = 0
}

async function onActivationOk() {
  if (formActivation.value.validate() && _personAddressForm.value.validate() && _insuranceIds.length > 0) {
    const items = await apiInsurance.InsuranceActivate( _value.person,_value.address,_insuranceIds,_value.activationDuration );
    if(items && items.length>0)
      _evbs.length = 0
      items.forEach(t=>_evbs.push(t.evb??""))
      _insuranceIds.length = 0
  }

}

function onCloseEvb() {
  _evbs.length=0
  _code.code1=""
  _code.code2=""
  _code.code3=""
}

async function checkActivationCode() {
    const res = await apiInsurance.checkActivationCode(_code.code1 + ' ' + _code.code2 + ' ' + _code.code3)
    if(!res)
      return
    if (res.activated) {
      notificationService.error("eVB wurde aktiviert.")
    }
    else{
      _value.person = new Person();
      _value.address = new Address();
      _value.address.countryCode = "DE"
      _insuranceIds.push(res.id)
    }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createVNode(SogCard, null, {
      default: _withCtx(() => [
        _createVNode(SogCardContent, null, {
          default: _withCtx(() => [
            _createVNode(SogFlexRow, null, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode(" Zum aktivieren der eVB, geben Sie bitte Ihre Anforderungscode ein: ", -1)
              ]))]),
              _: 1
            }),
            _createVNode(SogFlexRow, null, {
              default: _withCtx(() => [
                _createVNode(SogTextBox, {
                  ref_key: "inputCode1",
                  ref: inputCode1,
                  modelValue: _code.code1,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_code.code1) = $event)),
                  placeholder: "",
                  autocomplete: "false",
                  "max-length": "3",
                  "min-length": "3",
                  style: {"width":"4em"}
                }, null, 8, ["modelValue"]),
                _createVNode(SogTextBox, {
                  ref_key: "inputCode2",
                  ref: inputCode2,
                  modelValue: _code.code2,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_code.code2) = $event)),
                  placeholder: "",
                  autocomplete: "false",
                  "max-length": "3",
                  "min-length": "3",
                  style: {"width":"4em"}
                }, null, 8, ["modelValue"]),
                _createVNode(SogTextBox, {
                  ref_key: "inputCode3",
                  ref: inputCode3,
                  modelValue: _code.code3,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_code.code3) = $event)),
                  placeholder: "",
                  autocomplete: "false",
                  "max-length": "3",
                  "min-length": "3",
                  style: {"width":"4em"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(SogCardActionButton, {
            ref_key: "btnSearch",
            ref: btnSearch,
            "mdi-icon": "mdi-magnify",
            disabled: _isActivateDisabled.value,
            onClick: onClick
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" Suchen ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, !_isShowActivationForm.value && _evbs.length===0]
    ]),
    _withDirectives(_createVNode(SogCard, null, {
      default: _withCtx(() => [
        _createVNode(SogCardTitle, null, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode("eVB Aktivierung", -1)
          ]))]),
          _: 1
        }),
        _createVNode(SogCardContent, null, {
          default: _withCtx(() => [
            _createVNode(SogForm, {
              ref_key: "formActivation",
              ref: formActivation,
              validations: testValidation
            }, {
              default: _withCtx(() => [
                _createVNode(SogFormField, null, {
                  default: _withCtx(() => [
                    _createVNode(SogNumericTextBox, {
                      modelValue: _value.activationDuration,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_value.activationDuration) = $event)),
                      placeholder: "eVB-Gültigkeit (Tage)",
                      name: "activationDuration",
                      format: "n"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(PersonAddressForm, {
                  ref_key: "_personAddressForm",
                  ref: _personAddressForm,
                  person: _value.person,
                  address: _value.address
                }, null, 8, ["person", "address"])
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }),
        _createVNode(SogCardActions, null, {
          default: _withCtx(() => [
            _createVNode(SogCardActionButton, {
              "mdi-icon": "mdi-check",
              "button-style": _unref(SogButtonStyle).Primary,
              onClick: onActivationOk
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode(" Ok ", -1)
              ]))]),
              _: 1
            }, 8, ["button-style"]),
            _createVNode(SogCardActionButton, {
              "mdi-icon": "mdi-cancel",
              onClick: onActivationCancel
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" Abbrechen ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, _isShowActivationForm.value]
    ]),
    _withDirectives(_createVNode(SogCard, null, {
      default: _withCtx(() => [
        _createVNode(SogCardTitle, null, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createTextVNode("eVB", -1)
          ]))]),
          _: 1
        }),
        _createVNode(SogCardContent, null, {
          default: _withCtx(() => [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_evbs, (evb) => {
                return (_openBlock(), _createElementBlock("li", { key: evb }, _toDisplayString(evb), 1))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode(SogCardActions, null, {
          default: _withCtx(() => [
            _createVNode(SogCardActionButton, {
              "mdi-icon": "mdi-check",
              onClick: onCloseEvb
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode(" schliessen ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, _evbs.length>0]
    ])
  ]))
}
}

})